<div *ngIf="description">
  <micro-picklist [title]="description.display + 's'" [all]="all" [(selectedIds)]="selectedItems" (selectedIdsChange)="onNgModelChange($event)"></micro-picklist>
</div>

